import {Container, Dropdown, Form, Tab,} from "semantic-ui-react";
import {
    SurveySelectionConditionAction,
    SurveySelectionConditionActionToString,
    SurveySelectionConditionModel,
    SurveySelectionModel,
    SurveySelectionState
} from "../model/SurveySelectionModel";
import React, {useEffect, useState} from "react";
import AppListPage, {AppListPageDialogContext, AppListPageDialogContextState} from "../../common/AppListPage";
import {SurveySelectionConditionDataProvider} from "../service/SurveySelectionConditionDataProvider";
import SurveySelectionConditionDetails from "./SurveySelectionConditionDetails";
import {SurveySelectionListOptions} from "../model/SurveySelectionListOptions";
import {SurveySelectionItemDataProvider} from "../service/SurveySelectionItemDataProvider";
import {SurveySelectionItemModel} from "../model/SurveySelectionItemModel";
import {SurveySelectionItemListOptions} from "../model/SurveySelectionItemListOptions";
import {getPatientTitle, getSpecialGroupId, PatientTitleCase} from "../../../utils/common";
import {SpecialGroupDataProvider} from "../service/SpecialGroupsDataProvider";
import {SpecialGroup} from "../../dashboard";
import SearchableCheckboxList from "../../workTablePatients/EditorTabs/SearchableCheckboxList";

interface Props {
    context: AppListPageDialogContext<SurveySelectionModel>
}

const SurveySelectionDetails = (props: Props) => {

    const [name, setName] = useState<string>(props.context.model?.name ?? "");
    const [comment, setComment] = useState<string | undefined>(props.context.model?.comment);
    const [assignSpecialGroupIds, setAssignSpecialGroupIds] = useState<string[] | undefined>(props.context.model?.assignSpecialGroupIds);
    const [removeSpecialGroupIds, setRemoveSpecialGroupIds] = useState<string[] | undefined>(props.context.model?.removeSpecialGroupIds);

    const [nameError, setNameError] = useState<string>();
    const [loaded, setLoaded] = useState(false);
    const [specialGroups, setSpecialGroups] = useState<SpecialGroup[]>([]);

    useEffect(() => {
        (new SpecialGroupDataProvider()).list({limit: 10000, page: 1}).then((result) => {
            setSpecialGroups(result.items);
            setLoaded(true);
        });
    }, []);

    useEffect(() => {
        if (loaded) {
            Object.assign(props.context.model, {
                name: name,
                comment: comment,
                assignSpecialGroupIds: assignSpecialGroupIds,
                removeSpecialGroupIds: removeSpecialGroupIds
            });
            if ((name.length > 0) && nameError) setNameError(undefined);
        }
    }, [name, loaded, comment, assignSpecialGroupIds, removeSpecialGroupIds]);


    async function validate(): Promise<boolean> {
        let result = true;
        setNameError(undefined);
        if ((name?.length ?? 0) == 0) {
            setNameError("Наименование должно быть заполнено");
            result = false;
        }
        return result;
    }

    props.context.validateCallback = validate;

    const readOnly = props.context.state == AppListPageDialogContextState.view;
    const panes = [];


    if (props.context.model?.state == SurveySelectionState.completed && props.context.state == AppListPageDialogContextState.view) {
        panes.push({
            menuItem: 'Результаты выборки',
            render: () => <Tab.Pane style={{minHeight: 500}}>
                <div>
                    <AppListPage<SurveySelectionItemModel, SurveySelectionItemListOptions>
                        provider={new SurveySelectionItemDataProvider(props.context.model!.id)}
                        hideMenu={true}
                        columns={[
                            {key: "patient.surname", name: "Фамилия", accessor: (x) => x.patient.surname},
                            {key: "patient.name", name: "Имя", accessor: (x) => x.patient.name},
                            {key: "patient.middlename", name: "Имя", accessor: (x) => x.patient.middlename},
                            {key: "patient.tel", name: "Телефон", accessor: (x) => x.patient.tel},
                            {key: "patient.email", name: "Email", accessor: (x) => x.patient.email}
                        ]}/>
                </div>
            </Tab.Pane>

        });
    }

    function mapSpecialGroupIds(value: any | boolean | number | string | (boolean | number | string)[] | undefined) {
        const _value: string[] = [];
        if (value) {
            if (Array.isArray(value)) {
                Array.from(value).forEach((item) => {
                    _value.push(item.toString())
                })
            } else
                _value.push(value as string);
        }
        return value.length > 0 ? value : undefined;
    }

    panes.push(
        {
            menuItem: 'Параметры выборки', render: () => <Tab.Pane style={{minHeight: 500}}>
                <Container fluid>
                    <Form>
                        <Form.Input label={"Наименование выборки:"} required error={nameError} value={name}
                                    readOnly={readOnly}
                                    onChange={(e, data) => setName(data.value)}/>


                        <Form.TextArea label={"Примечания"} value={comment}
                                       readOnly={readOnly}
                                       onChange={(e, v) => setComment(v.value?.toString())}/>
                        <Form.Field>
                            <label>Критерии отбора</label>
                            <AppListPage<SurveySelectionConditionModel, SurveySelectionListOptions>
                                provider={new SurveySelectionConditionDataProvider(props.context.model!)}
                                hidePaging={true}
                                readOnly={readOnly}
                                gridHeight={"250px"}
                                newItemCreator={() => {
                                    return {
                                        id: 0,
                                        action: SurveySelectionConditionAction.include,
                                        campaign: {id: "", name: ""},
                                        form: {id: "", name: ""},
                                        answers: []
                                    } as SurveySelectionConditionModel
                                }}
                                getDetailsComponent={(context) => <SurveySelectionConditionDetails context={context}/>}
                                hideSearch={true}
                                columns={[
                                    {key: "id", name: "#", accessor: (x) => x.id + 1, width: 50},
                                    {key: "campaignName", name: "Кампания", accessor: (x) => x.campaign?.name},
                                    {
                                        key: "action",
                                        name: "Действие",
                                        accessor: (x) => SurveySelectionConditionActionToString(x.action)
                                    },
                                    {key: "answersCount", name: "Кол-во условий", accessor: (x) => x.answers.length},
                                ]}/>
                        </Form.Field>
                        <Form.Group>
                            <Form.Dropdown width={6}
                                           multiple
                                           placeholder={"Выберите особые группы"}
                                           selection
                                           fluid
                                           disabled={readOnly}
                                           clearable
                                           label={"Присвоить выбранным особые группы"}
                                           value={assignSpecialGroupIds ?? []}
                                           options={specialGroups.map((sg) => ({
                                               key: sg._id,
                                               text: `${sg.name} `,
                                               value: sg._id,
                                           }))}
                                           onChange={(e, data) => {
                                               setAssignSpecialGroupIds(mapSpecialGroupIds(data.value));
                                           }}
                            >

                            </Form.Dropdown>
                            <Form.Dropdown width={6}
                                           multiple
                                           placeholder={"Выберите особые группы"}
                                           selection
                                           fluid
                                           disabled={readOnly}
                                           clearable
                                           label={"Удалить для выбранных особые группы"}
                                           value={removeSpecialGroupIds ?? []}
                                           options={specialGroups.map((sg) => ({
                                               key: sg._id,
                                               text: `${sg.name} `,
                                               value: sg._id,
                                           }))}
                                           onChange={(e, data) => {
                                               setRemoveSpecialGroupIds(mapSpecialGroupIds(data.value));
                                           }}
                            >

                            </Form.Dropdown>
                        </Form.Group>
                    </Form>
                </Container>
            </Tab.Pane>
        });

    return <>{loaded && <Tab panes={panes}/>}</>;
}

export default SurveySelectionDetails;